// extracted by css-extract-rspack-plugin
export default {"cls1":"FilterPanel-cls1_dDM","cls2":"FilterPanel-cls2_yq9 FilterPanel-cls1_dDM","filtersFadeIn":"FilterPanel-filtersFadeIn_cwX"};